// ACCOUNT OBJECT:
module.exports = function (id, name, data, config) {
  // INIT:
  data = data || {};
  this.id = id;
  this.name = name;
  this.score = data.player_score || 0;
  this.kills = data.player_kills || 0;
  this.deaths = data.player_deaths || 0;
  this.wins = data.player_wins || 0;
  this.hack = data.player_hack || 0;
  this.games = data.player_games_played || 0;
  this.clan = data.player_clanid;
  this.funds = data.player_funds || 0;
  this.featured = data.player_featured || 0;
  this.clan = data.player_clan || null;
  this.timePlayed = data.player_timeplayed || 0;
  this.skins = data.skins || [];
  this.lastReward = data.player_lastreward || 0;
  this.developer = data.player_developer || 0;
  this.following = data.player_follow || 0;
  this.followers = data.player_followed || 0;
  this.isFollowing = data.player_following || 0;
  this.stats = data.player_stats ? JSON.parse(data.player_stats) : {};

  // SET DATA:
  this.setData = function (data) {
    this.kills = data[1];
    this.wins = data[2];
    this.games = data[3];
    this.deaths = data[4];
    this.funds = data[5];
    this.score = data[6];
    this.updateLevel();
    this.clan = data[7];
    this.timePlayed = data[8];
    this.featured = data[9];
    this.skins = data[10];
    this.lastReward = data[11];
    this.developer = data[12];
    this.following = data[13];
    this.followers = data[14];
    this.isFollowing = data[15];
    this.stats = data[16];
    this.hack = data[17];
  };

  // SET LEVEL:
  this.updateLevel = function () {
    var tmpRank = config.rankVar * Math.sqrt(this.score);
    this.level = Math.floor(tmpRank);
    this.levelProg = Math.round((tmpRank - this.level) * 100);
    this.level = Math.max(1, this.level);
  };
  this.updateLevel();

  // GET DATA:
  this.getData = function () {
    return [this.id, this.kills, this.wins, this.games, this.deaths, this.funds, this.score, this.clan, this.timePlayed, this.featured, this.skins, this.lastReward, this.developer, this.following, this.followers, this.isFollowing, this.stats, this.hack];
  };
};